/**
 * Decision logic for the destructive "Tilbakestill ordre" action (#362).
 *
 * Extracted to pure functions so the gate in front of admin.reset_order_status
 * (which deletes delivery data) is unit-testable. Mirrors the server guard in
 * migration 104 — the server remains the authority; this only controls UI.
 */

/** Reset button is offered only to admin/owner, and only on delivered orders. */
export function canResetOrder(
  role: string | null | undefined,
  appStatus: string | null | undefined,
): boolean {
  const isAdmin = role === 'admin' || role === 'owner'
  return isAdmin && appStatus === 'delivered'
}

/** Server (mig 104) requires a trimmed reason of at least 10 characters. */
export function isResetReasonValid(reason: string): boolean {
  return reason.trim().length >= 10
}
